import * as React from "react";
import { AppContext } from "@msidata/zeact";
export const useAppContext = () => React.useContext(AppContext);
